// extracted by css-extract-rspack-plugin
export default {"TableID":"VsFXB","cellData":"QrJrB"};